(function () {
  const SRC = 'https://cdn.sesami.co/storefront/latest/sesami-main.js';

  function experiences() {
    return document.querySelectorAll('sesami-experience[data-custom-sesami-button]');
  }

  function ensureSesami() {
    if (window.customElements && window.customElements.get('sesami-experience')) return;
    if (document.querySelector('script[src*="cdn.sesami.co/storefront"]')) return;

    const script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    document.head.appendChild(script);
  }

  function quantityFor(el) {
    const form = document.getElementById(el.dataset.productFormId || '');
    const input = form && form.querySelector('input[name="quantity"]');
    const value = input ? parseInt(input.value, 10) : 1;
    return value > 0 ? String(value) : '1';
  }

  function syncQuantity(el) {
    el.setAttribute('quantity', quantityFor(el));
  }

  function openSesami(el) {
    if (!el) return;

    if (typeof el.openExperience === 'function') {
      el.openExperience();
      return;
    }

    if (el.dataset.pendingOpen === 'true') return;
    el.dataset.pendingOpen = 'true';

    window.addEventListener(
      'sesami:loaded',
      function () {
        el.dataset.pendingOpen = 'false';
        if (typeof el.openExperience === 'function') el.openExperience();
      },
      { once: true }
    );
  }

  function init() {
    ensureSesami();
    experiences().forEach(syncQuantity);
  }

  if (!window.__customSesamiButtonBound) {
    window.__customSesamiButtonBound = true;

    document.addEventListener('click', function (event) {
      const button = event.target.closest('[data-sesami-open]');
      if (!button) return;

      event.preventDefault();
      openSesami(document.getElementById(button.getAttribute('data-sesami-open')));
    });

    document.addEventListener('variant:change', function (event) {
      const variant = event.detail && event.detail.variant;
      if (!variant || !variant.id) return;

      experiences().forEach(function (el) {
        el.setAttribute('variant-id', String(variant.id));
      });
    });

    document.addEventListener('change', function (event) {
      const target = event.target;
      if (!target || target.name !== 'quantity') return;

      experiences().forEach(function (el) {
        const form = document.getElementById(el.dataset.productFormId || '');
        if (form && form.contains(target)) syncQuantity(el);
      });
    });

    document.addEventListener('shopify:section:load', init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
